module.exports = __webpack_public_path__ + "img/clothing-delivery.b697c18c.png";